import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { DeliberyNoteServices } from "../../services";
import { ProviderOrderViewPage } from '../../../providers/orders/provider-order-view/provider-order-view';
import { ProvidersServices } from '../../../providers/services';
import { ExpensesDenoCreateDataPage } from '../../../income-expenses/expenses-deno-create/expenses-deno-create-data/expenses-deno-create-data';
import { TranslateService } from '@ngx-translate/core';
import { IncomeExpensesListPage } from '../../../income-expenses/income-expenses-list/income-expenses-list';
import { DeliberyNoteListPage } from '../../delibery-note-list/delibery-note-list';
import { DeliberyNoteResultFotoIa } from '../../delibery-note-create/delibery-note-result-foto-ia/delibery-note-result-foto-ia';
import { first } from 'rxjs/operators';

/**
 * Generated class for the DeliberyNoteListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-delibery-note-view',
    templateUrl: 'delibery-note-view.html',
})
export class DeliberyNoteViewPage {
    delibery_note_uid: string;
    denos: any = Array();
    valueChanges: any;
    sub_total: any = 0;
    total: any = 0;
    view_delibery_after_create: boolean = false

    // Función para redondear números a 2 decimales
    round(num: number, decimales: number = 2): number {
        const factorDeEscala = Math.pow(10, decimales);
        return Math.round(num * factorDeEscala) / factorDeEscala;
    }

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public deliberyNoteServices: DeliberyNoteServices,
        public providersServices: ProvidersServices,
        public translate: TranslateService,
        private cdRef: ChangeDetectorRef
    ) {

        this.globals.GAtrackView('Stock', 'Stock - Delibery note - View', this.globals.restaurant.email, 'View', 'View delibery note', 'Stock', '');


        this.delibery_note_uid = this.navParams.get('delibery_note_uid');
        // view_delibery_after_create es para hacer un set root a la pagina delibery-note-view y no perjudicar otras paginas
        this.view_delibery_after_create = this.navParams.get('view_delibery_after_create')


        this.deliberyNoteServices.deliberyNoteDoc = this.deliberyNoteServices.afs.doc('delibery_note/' + this.delibery_note_uid); //Recuperamos el ingrediente para tener el plato simpre actulizado.
        this.valueChanges = this.deliberyNoteServices.deliberyNoteDoc.valueChanges().pipe(
            first()
        ).subscribe(value => {

            value.UID = this.delibery_note_uid; //Anadimos el UID al plato
            this.denos = value;

            // Inicializar totales
            this.sub_total = 0;
            this.total = 0;

            if (this.denos.uid_provider_order == undefined) {
                this.denos.uid_provider_order = '';
            }
            //
            if (this.denos.list) {
                for (let element of this.globals.objectToArray(this.denos.list)) {
                    var sub = this.globals.calculatePrice(element.price, element.quantity, element.measurement);
                    if (element.type_discount === undefined || element.type_discount === 'discount_percentage') {
                        this.sub_total += sub - ((sub * element.discount) / 100);
                    } else {
                        this.sub_total += sub - element.discount;
                    }
                    this.total += element.total;
                }
                
                // Redondear los totales a 2 decimales para evitar errores de precisión
                this.sub_total = this.round(this.sub_total);
                this.total = this.round(this.total);
            }

            this.cdRef.detectChanges(); // Llama a detectChanges después de actualizar los datos
        });

    }

    ionViewDidLeave() {
        if (this.view_delibery_after_create) {
            this.navCtrl.setRoot(DeliberyNoteListPage);
        }
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-albaran'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Stock', 'Stock - Delibery note - Delete', this.globals.restaurant.email, 'Delete', 'Delete delibery note', 'Stock', this.denos.number);
                        this.valueChanges.unsubscribe();
                        this.deliberyNoteServices.delete(this.delibery_note_uid);
                        //this.navCtrl.pop();
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }


    // para poder editar el albaran , mandamos un json donde se manejan los alabaranes al update y mandamos que es un upadate
    edit() {
        this.view_delibery_after_create = false;
        
        this.navCtrl.push(DeliberyNoteResultFotoIa, {
            json_Response: this.denos,
            update_state: true,
            show_alert: false
        });        
    }


    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.setRoot(DeliberyNoteListPage);
        loadingPopup.dismiss();
    }

    async openProviderOrderView(uid_provider_order) {
        var provider_order = await this.providersServices.getProviderOrder(uid_provider_order);
        this.navCtrl.push(ProviderOrderViewPage,
            {
                provider_order: provider_order
            });
    }

    createExpenses(uid_provider, provider_static, deno) {

        //push delibery_note a tmp per crear gasto
        this.deliberyNoteServices.delibery_notes_array_tmp = Array();
        var _array = Array();
        _array.push(deno.UID);
        _array.push(this.globals.timestampToDate(deno.date));
        _array.push(deno.list);
        _array.push(deno.number);
        _array.push(deno.provider_static);
        _array.push(deno.uid_provider);
        _array.push(deno.uid_provider_order);
        _array.push(this.total);
        this.deliberyNoteServices.delibery_notes_array_tmp.push(_array);
        //push per crear gasto
        this.view_delibery_after_create = false;
        this.navCtrl.push(ExpensesDenoCreateDataPage, {
            provider: uid_provider + ',;,' + provider_static,
        })

    }

    openIE() {
        this.globals.side_menu_active = 'inexp';
        this.navCtrl.push(IncomeExpensesListPage);
    }


}



// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-view/delibery-note-view/delibery-note-view.ts